enum JobTagStrictness {
  REQUIRED = "required",
  PREFERRED = "preferred",
  TYPICALLY_REQUIRED = "typically required",
}

export default JobTagStrictness;
